import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaLock } from 'react-icons/fa';
import { PopupContext } from '../App';
import AuthLayout, { AuthFields, AuthFooter, AuthSubmitRow } from '../features/auth/components/AuthLayout';
import authStyles from '../features/auth/components/AuthLayout.module.css';
import Button from '../shared/ui/Button';
import Input from '../shared/ui/Input';
import axios from 'axios';
import useResetToken from './useResetToken';


export default function SetPasswordPage() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const showPopup = useContext(PopupContext);
  const navigate = useNavigate();
  const { token, valid } = useResetToken();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      showPopup('Passwords do not match', 'error');
      return;
    }
    if (!token) {
      showPopup('Missing reset token', 'error');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/api/auth/set-password', { token, password });
      showPopup('Password set successfully!', 'success');
      setTimeout(() => navigate('/login', { replace: true }), 600);
    } catch (err) {
      showPopup('Failed to set password', 'error');
    } finally {
      setLoading(false);
    }
  };

  if (valid === false) {
    return (
      <AuthLayout
        tone="danger"
        title="Invalid reset link"
        subtitle="This password reset link is missing, expired, or has already been used."
      >
        <p className={authStyles.errorHint}>Request a new link from the sign-in page if you still need access.</p>
        <AuthFooter>
          <Link className={authStyles.textLink} to="/login">
            Return to sign in
          </Link>
        </AuthFooter>
      </AuthLayout>
    );
  }
  return (
    <AuthLayout
      title="Set new password"
      subtitle="Choose a strong password you have not used elsewhere."
    >
      <form onSubmit={handleSubmit} noValidate>
        <AuthFields>
          <Input
            type="password"
            label="New password"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="new-password"
            iconLeft={<FaLock />}
          />
          <Input
            type="password"
            label="Confirm password"
            placeholder="••••••••"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            autoComplete="new-password"
            iconLeft={<FaLock />}
          />
        </AuthFields>
        <AuthSubmitRow>
          <Button type="submit" size="lg" loading={loading}>
            Save password
          </Button>
        </AuthSubmitRow>
      </form>
    </AuthLayout>
  );
}
